import React from "react";
import { View, Text, StyleSheet, ScrollView, Image, TouchableOpacity } from "react-native";
import { FontAwesome } from "@expo/vector-icons";

const PropertyDetailScreen = ({ navigation, route }: any) => {
  const { property } = route.params; // Assuming property data is passed as route params

  return (
    <ScrollView contentContainerStyle={styles.container}>
      {/* Property Images */}
      <Image 
        source={typeof property.image === "string" ? { uri: property.image } : property.image} 
        style={styles.propertyImage} 
      />
      
      {/* Property Details */}
      <View style={styles.detailsContainer}>
        <Text style={styles.propertyTitle}>{property.title}</Text>
        <Text style={styles.propertyPrice}>Price: {property.price} CFA</Text>
        <Text style={styles.propertyLocation}>Location: {property.location}</Text>
        <Text style={styles.propertyDescription}>
          {property.description || "No description available."}
        </Text>
      </View>

      {/* Action Buttons */}
      <View style={styles.actionButtons}>
        <TouchableOpacity
          style={styles.contactButton}
          onPress={() => navigation.navigate("MessagesScreen", { sellerId: property.sellerId })}
        >
          <FontAwesome name="envelope" size={20} color="#fff" />
          <Text style={styles.contactButtonText}>Contact Seller</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.offerButton}
          onPress={() => navigation.navigate("OfferScreen", { property })}
        >
          <FontAwesome name="tag" size={20} color="#fff" />
          <Text style={styles.offerButtonText}>Make an Offer</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 20,
    backgroundColor: "#fff",
  },
  propertyImage: {
    width: "100%",
    height: 250,
    borderRadius: 10,
    marginBottom: 20,
  },
  detailsContainer: {
    marginBottom: 20,
  },
  propertyTitle: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 10,
  },
  propertyPrice: {
    fontSize: 18,
    color: "#444",
    marginBottom: 5,
  },
  propertyLocation: {
    fontSize: 16,
    color: "#444",
    marginBottom: 10,
  },
  propertyDescription: {
    fontSize: 14,
    color: "#666",
  },
  actionButtons: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  contactButton: {
    flexDirection: "row",
    backgroundColor: "#007BFF",
    padding: 15,
    borderRadius: 10,
    alignItems: "center",
  },
  contactButtonText: {
    color: "#fff",
    marginLeft: 10,
    fontSize: 16,
  },
  offerButton: {
    flexDirection: "row",
    backgroundColor: "green",
    padding: 15,
    borderRadius: 10,
    alignItems: "center",
  },
  offerButtonText: {
    color: "#fff",
    marginLeft: 10,
    fontSize: 16,
  },
});

export default PropertyDetailScreen;
